import { oc } from '@orpc/contract';
import { getReportInputSchema, reportDetailSchema } from '../schemas/reports.schemas.js';
export const getReportContract = oc
    .route({
    method: 'GET',
    path: '/reports/{id}',
    tags: ['Reports'],
    summary: 'Read one saved report, including the frozen snapshot the renderer prints',
    description: 'Returns the snapshot exactly as it was stored, byte for byte, however much the validity rules, the compatibility configuration or the underlying runs have moved on since (plan §4 `reports`).',
})
    .input(getReportInputSchema)
    .output(reportDetailSchema);
//# sourceMappingURL=get-report.contract.js.map